module.exports = __webpack_public_path__ + "img/no-checkin.088ba869.svg";